import { UserPage } from '@pages/user';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Профиль пользователя', 'Информация о пользователе');
}

export default UserPage;
